export function detailHref(id) {
  return `#/detail/${encodeURIComponent(String(id))}`
}

export function scrollPageToTop() {
  window.scrollTo(0, 0)
  if (document.documentElement) {
    document.documentElement.scrollTop = 0
  }
  if (document.body) {
    document.body.scrollTop = 0
  }
}

export function goTrademarkDetail(id) {
  const target = detailHref(id)
  if (window.location.hash === target) {
    scrollPageToTop()
    return
  }
  window.location.hash = target
}

export function isModifiedNavigationClick(event) {
  return Boolean(
    event &&
    (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1)
  )
}
